import { render, staticRenderFns } from "./CVTypeProject.vue?vue&type=template&id=00b90b24"
import script from "./CVTypeProject.vue?vue&type=script&lang=js"
export * from "./CVTypeProject.vue?vue&type=script&lang=js"
import style0 from "./CVTypeProject.vue?vue&type=style&index=0&id=00b90b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports